<template>
  <el-dialog
    title="批量导入物料信息"
    :visible.sync="batchImportVisible"
    width="506px"
    :before-close="canceBatchImportlHandle"
    class="batch-import"
    append-to-body
  >
    <el-form ref="uploadForm" size="small">
      <el-form-item label="下载模版:" label-width="100px" prop="">
        <span @click="downloadTem" class="download-text">物料信息批量上传模版.xlsx</span>
      </el-form-item>
      <el-form-item label="上传模板:" label-width="100px">
        <el-upload
          ref="uploadFile"
          class="upload-file"
          :http-request="uploadFile"
          :file-list="fileList"
          :auto-upload="false"
          :before-upload="beforeUpload"
          :on-change="onChange"
          :on-success="handleFileSuccess"
          :before-remove="beforeRemove"
          :on-remove="handleRemove"
          :headers="headers"
          name="fileList"
          action=".xlsx"
          :limit="1"
          :on-exceed="handleExceed"
          :disabled="uploadLoading"
        >
          <el-button size="small" type="primary">选择文件</el-button>
          <!-- <template>
            <div class="error">
              请选择文件
            </div>
          </template> -->
        </el-upload>
      </el-form-item>
      <el-form-item style="margin: 0">
        <div class="hint">
          提示：请先下载“物料信息批量上传模板”，按模板格式填写物料信息，并完成上传。
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        :disabled="uploadLoading"
        :loading="uploadLoading"
        size="small"
        type="primary"
        @click="submitUpload"
      >
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import utils from '@/modules/projectA/utils/utils';
import { Message } from 'element-ui';
import Api from '@/modules/projectA/api/purchase';
export default {
  props: {
    limit: {
      type: Number,
      default: 1,
    },
    fileSize: {
      type: Number,
      default: 3,
    },
    batchImportVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileList: [],
      uploadLoading: false,
      headers: {},
      downloadUrl: '',
    };
  },
  components: {},
  methods: {
    async downloadTem() {
      await Api.excelDownload({}).then(res => {
        if (res.type == 'application/json') {
          utils.fileExportResponseError(res);
        } else {
          utils.downFile(res, '采购计划-物料导入模板');
        }
      });
    },
    // 上传文件提交
    submitUpload() {
      // 执行文件上传的函数，其实也就是调用 uploadFile方法 来获取我们要上传的文件
      this.$refs.uploadFile.submit();
      if (this.fileList.length !== 1) {
        this.$message({
          message: '请选择需要上传的文件!',
          type: 'error',
        });
        return;
      }
      // 通过 FormData 对象上传文件
      const file = new FormData();
      this.fileList.forEach(function(item) {
        // 因为要上传多个文件，所以需要遍历
        file.append('file', item, item.name);
      });
      // console.log(file, "批量");
      this.uploadLoading = true;
      /* setTimeout(() => {
        this.uploadLoading = false;
        this.$emit("getbatchImportList", []);
        this.canceBatchImportlHandle();
      }, 3000); */
      console.log(file);
      // return;
      Api.excelUpload(file)
        .then(res => {
          console.log('_RequestUploads_', res);
          if (res.code === '200') {
            this.uploadLoading = false;
            this.$emit('getbatchImportList', res.data);
            this.canceBatchImportlHandle();
          } else {
            Message.closeAll();
            this.$message({
              dangerouslyUseHTMLString: true,
              message: res.message,
              type: 'error',
            });
          }
        })
        .finally(() => {
          this.uploadLoading = false;
          this.fileList = [];
          this.$refs.uploadFile.clearFiles();
        })
        .catch(err => {
          console.log(err);
          this.$refs.uploadFile.clearFiles();
        });
    },
    // 关闭弹窗
    canceBatchImportlHandle() {
      this.$emit('update:batchImportVisible', false);
      this.fileList.splice(0, 1);
      this.$refs.uploadFile.clearFiles();
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.error(`当前限制选择 ${this.limit} 个文件`);
    },
    // 文件fliesize及格式校验
    isFileSize(file) {
      if (file.size / 1024 / 1024 > this.fileSize) {
        this.$message({
          message: `请上传小于${this.fileSize}M的文件!`,
          type: 'error',
        });
        return false;
      }
      if (file.name.includes(',')) {
        this.$message({
          message: '文件名格式错误!',
          type: 'error',
        });
        return false;
      }
      return true;
    },
    // 以下是上传文件需要的方法
    commonHandleCheck(val) {
      let testmsg = val.substring(val.lastIndexOf('.') + 1);
      testmsg && (testmsg = testmsg.toLowerCase());
      return testmsg;
    },

    // 验证调删除事件时的文件规则
    fileFormat(file) {
      let testmsg = this.commonHandleCheck(file.name);
      const isXls = testmsg === 'xls';
      const isXlsx = testmsg === 'xlsx';
      /* const isDoc = testmsg === " doc";
      const isDocx = testmsg === "docx";
      const isPdf = testmsg === "pdf";
      const isJpg = testmsg === "jpg";
      const isJpeg = testmsg === "jpeg";
      const isPng = testmsg === "png"; */
      return isXls || isXlsx /* || isDoc || isDocx || isPdf || isJpg || isJpeg || isPng */;
    },
    // 上传之前文件验证
    beforeUpload(file) {
      if (!this.isFileSize(file)) {
        this.$message.closeAll();
        this.$message({
          message: `上传文件大小不能超过 ${this.fileSize}MB!`,
          type: 'error',
        });
        console.log('放松放松放松');
        return false;
      }
      let testmsg = this.commonHandleCheck(file.name);
      const isXls = testmsg === 'xls';
      const isXlsx = testmsg === 'xlsx';
      console.log(isXls, isXlsx);
      if (!isXlsx && !isXls) {
        this.$message({
          message: '上传文件只能是xls、xlsx格式!',
          type: 'error',
        });
        fileList.length && this.$refs.uploadFile.clearFiles();
        console.log('放松放松放松的发生的方式');
        return false;
      }

      return (isXlsx || isXls) && this.isFileSize(file);
    },
    // 改变文件的钩子
    onChange(file, fileList) {
      if (!this.isFileSize(file)) {
        this.$message.closeAll();
        this.$message({
          message: `上传文件大小不能超过 ${this.fileSize}MB!`,
          type: 'error',
        });
        // 的清空数据
        fileList.length && this.$refs.uploadFile.clearFiles();
        return false;
      }
      console.log('改变文件的钩子', fileList);
      let testmsg = this.commonHandleCheck(file.name);
      const isXls = testmsg === 'xls';
      const isXlsx = testmsg === 'xlsx';
      console.log(isXls, isXlsx);
      if (!isXlsx && !isXls) {
        this.$message({
          message: '上传文件只能是xls、xlsx格式!',
          type: 'error',
        });
        fileList.length && this.$refs.uploadFile.clearFiles();
        return false;
      }
      // 只能上传excel
      return isXls || isXlsx /* || isDoc || isDocx || isPdf || isJpg || isJpeg || isPng */;
    },
    // 上传成功的钩子
    handleFileSuccess(response, file, fileList) {
      /* this.$refs.uploadFile.clearFiles();
      // 不管成功还是失败都将弹窗中选择的文件清空
      for (let index = 0; index < fileList.length; index++) {
        fileList.splice(index, 1);
      }
      this.fileList = []; */
      console.log(file, fileList, '上传成功的钩子111');
    },
    // 移除前的钩子
    beforeRemove(file) {
      console.log(file, '移除前的钩子');
      if (this.fileFormat(file)) {
        // 删除提示
        return this.$confirm(`确定永久移除 ${file.name}？`, '提示');
      }
    },
    // 上传失败的钩子
    errFunction(file, fileList) {
      console.log(file, fileList);
      this.$message.error('上传失败');
    },
    // 移除的钩子
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList.splice(0, 1);
      this.$refs.uploadFile.clearFiles();
    },
    // 这里就是的到需要上传文件的集合
    uploadFile(params) {
      this.fileList.push(params.file);
    },
  },
};
</script>
<style lang="scss" scoped>
.batch-import {
  .download-text {
    text-decoration: underline;
    color: #0064c8;
    font-size: 14px;
    cursor: pointer;
  }
  .hint {
    margin-left: 30px;
    word-wrap: break-word;
    color: #666666;
    font-size: 14px;
    line-height: 1.3;
  }
  .upload-file {
    position: relative;
    .error {
      position: absolute;
      left: 0;
      top: 28px;
      color: red;
      font-size: 12px;
    }
    ::v-deep .el-button {
      border-radius: 0;
      min-width: 80px;
      height: 30px;
    }
  }
  ::v-deep.el-dialog__body {
    padding: 10px;
  }
  ::v-deep.el-dialog__header {
    background: #f5f5f5;
    height: 40px;
    padding: 0 20px;
    line-height: 40px;
    .el-dialog__headerbtn {
      top: 8px;
    }
    .el-dialog__title {
      font-size: 14px;
    }
  }

  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: center;
    .el-button {
      border-radius: 0;
      min-width: 80px;
      height: 30px;
    }
  }
}
</style>
